export default __webpack_public_path__ + "static/media/640_dummy2016-yoga01-mobile-de.442f0c05.png";